(function(){var L=document.getElementById("wfList");if(!L)return;
var items=[].slice.call(L.querySelectorAll(".wf-item"));
var inp=document.getElementById("wfSearch"),clr=document.getElementById("wfClear"),emp=document.getElementById("wfEmpty");
var box=inp?inp.closest(".wf-search"):null;var tabs=[].slice.call(document.querySelectorAll(".wf-tab"));var cat="all";
function norm(s){return (s||"").toLowerCase().replace(/\s+/g," ").trim()}
function apply(){var q=norm(inp?inp.value:"");var n=0;
 items.forEach(function(it){var okC=(cat==="all"||it.getAttribute("data-cat")===cat);
  var okQ=!q||norm(it.getAttribute("data-k")+" "+it.textContent).indexOf(q)>=0;
  var show=okC&&okQ;it.hidden=!show;if(show)n++;if(!show)it.open=false;
  if(show&&q&&q.length>1)it.open=true;else if(!q)it.open=false;});
 if(emp)emp.hidden=n>0;
 if(box)box.classList.toggle("has-v",!!(inp&&inp.value));}
if(inp){var t;inp.addEventListener("input",function(){clearTimeout(t);t=setTimeout(apply,140)});}
if(clr&&inp){clr.addEventListener("click",function(){inp.value="";apply();inp.focus()});}
tabs.forEach(function(b){b.addEventListener("click",function(){cat=b.getAttribute("data-cat");tabs.forEach(function(x){x.classList.toggle("is-on",x===b)});apply();});});
items.forEach(function(it){it.addEventListener("toggle",function(){if(it.open){items.forEach(function(o){if(o!==it)o.open=false})}})});
})();